import dayjs from "dayjs";
import { TFunction } from "i18next";
import { ExpiringLeaseItem } from "~/types/finance";

export function getTenantDisplayName(item: ExpiringLeaseItem): string {
  const first = item.tenant?.firstName?.trim() ?? "";
  const last = item.tenant?.lastName?.trim() ?? "";
  const name = [first, last].filter(Boolean).join(" ");
  return name || item.tenant?.id || "N/A";
}

export function formatEndDateLabel(endDate: string): string {
  const parsed = dayjs(endDate);
  return parsed.isValid() ? parsed.format("MMM D, YYYY") : endDate;
}

export function formatExpirationLabel(
  item: ExpiringLeaseItem,
  t: TFunction<"translation">,
): string {
  const dateLabel = formatEndDateLabel(item.endDate);
  if (item.isExpired) {
    return `${t("Expired")} - ${dateLabel}`;
  }
  return t("Lease_ends_on_days", {
    date: dateLabel,
    days: item.daysUntilEnd,
  });
}
